export var fakeData = [
  {
    id: 1,
    name: "Child Support",
    image: "https://i.imgur.com/b1rl5GT.png",
    color: "#FFBD3E",
  },
  {
    id: 2,
    name: "Refuge Shelter",
    image: "https://i.imgur.com/3ZX2wAT.png",
    color: "#FF7044",
  },
  {
    id: 3,
    name: "Food Charity",
    image: "https://i.imgur.com/PQDsE9s.png",
    color: "#3F90FC",
  },
  {
    id: 4,
    name: "Host a Clothing Swap",
    image: "https://i.imgur.com/JelpHES.png",
    color: "#421FCF",
  },
  {
    id: 5,
    name: "Host a River Cleanup",
    image: "https://i.imgur.com/kpaXsSh.png",
    color: "#3F90FC",
  },
  {
    id: 6,
    name: "Clean-up Water for Children",
    image: "https://i.imgur.com/BFTmVBV.png",
    color: "#421FCF",
  },
  {
    id: 7,
    name: "Good Education",
    image: "https://i.imgur.com/QO3fWfm.png",
    color: "#FFBD3E",
  },
  {
    id: 8,
    name: "New Books for Children",
    image: "https://i.imgur.com/6uTfF1Z.png",
    color: "#FF7044",
  },
  {
    id: 9,
    name: "Host a study group.",
    image: "https://i.imgur.com/2hmSw43.png",
    color: "#FFBD3E",
  },
  {
    id: 10,
    name: "Build birdhouses for your neighbors",
    image: "https://i.imgur.com/CJ9NIuJ.png",
    color: "#3F90FC",
  },
  {
    id: 11,
    name: "Organize books at the library.",
    image: "https://i.imgur.com/GXBwQxY.png",
    color: "#FF7044",
  },
  {
    id: 12,
    name: "Give a seminar on driving safety.",
    image: "https://i.imgur.com/qmCr1M9.png",
    color: "#421FCF",
  },
  {
    id: 13,
    name: "Give free music lessons.",
    image: "https://i.imgur.com/O9TWJfa.png",
    color: "#421FCF",
  },
  {
    id: 14,
    name: "Teach people how to register to vote.",
    image: "https://i.imgur.com/5OBol2a.png",
    color: "#FFBD3E",
  },
  {
    id: 15,
    name: "Clean up your local park.",
    image: "https://i.imgur.com/SCJ5Y62.png",
    color: "#3F90FC",
  },
  {
    id: 16,
    name: "Give IT help to local adults",
    image: "https://i.imgur.com/VIIhFRk.png",
    color: "#FF7044",
  },
  {
    id: 17,
    name: "Foster a shelter animal.",
    image: "https://i.imgur.com/Pc0R5JE.png",
    color: "#FFBD3E",
  },
  {
    id: 18,
    name: "Babysit during PTA meetings.",
    image: "https://i.imgur.com/76AhquV.png",
    color: "#3F90FC",
  },
  {
    id: 19,
    name: "Collect stuffed animals.",
    image: "https://i.imgur.com/XNgQHiL.png",
    color: "#FF7044",
  },
  {
    id: 20,
    name: "Collect school supplies.",
    image: "https://i.imgur.com/L8r38Cy.png",
    color: "#421FCF",
  },
];
